import { render, staticRenderFns } from "./ViewBuild.vue?vue&type=template&id=70ec930f&scoped=true&"
import script from "./ViewBuild.vue?vue&type=script&lang=js&"
export * from "./ViewBuild.vue?vue&type=script&lang=js&"
import style0 from "./ViewBuild.vue?vue&type=style&index=0&id=70ec930f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ec930f",
  null
  
)

export default component.exports